'use strict';

exports.__esModule = true;
var ERRORS = exports.ERRORS = {
  NO_BREAKPOINTS: 'react-breakpoints requires you to pass an object of breakpoints, see documentation at: https://github.com/ehellman/react-breakpoints',
  NOT_OBJECT: 'react-breakpoints requires you to pass an object of breakpoints, see documentation at: https://github.com/ehellman/react-breakpoints'
};